module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Bold.7f281199.ttf";